/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"hamW7u":["Unlocked"],"Se/EPN":["https://khanacademy.wufoo.com/forms/m4l36ta1kwdzcz/"],"wrQx4y":["https://khanacademy.wufoo.com/forms/zccnv0r1bitlvl/"],"pExvA7":["Apply here now!"],"93u4GI":["Let us know you are interested!"],"6NM7uo":["Applications are closed. Check back soon."],"6+GXCi":["Become a Khan Academy Ambassador"],"JuWZOe":["Share your enthusiasm for providing a free, world-class education for all while growing personally and professionally: join our network of inspiring educators who are spreading their expertise to teachers and classrooms around the United States!"],"q/4TGl":["Applications for the Khan Academy Ambassador Program are currently closed. Please fill out the survey below to let us know you are interested! We will notify you when applications re-open."],"Snuwfy":["Khan Academy Ambassador Program"],"IyCeAq":["Who are Khan Academy Ambassadors?"],"fWOxXY":["Khan Academy Ambassadors are ambitious, energetic, and knowledgeable educators who are experts in using Khan Academy within a classroom context. They believe deeply in our mission and are ready to super-charge student practice on Khan Academy throughout their school and community during the 2019-2020 school year. We’ll provide you with Khan Academy materials and a powerful community, and equip you to share Khan Academy and support its use however best suits your style."],"AkVNAG":["We believe that educators are THE difference-makers in the classroom and beyond. Our team cannot wait to partner with Khan Academy Ambassadors to learn and grow as an organization and, together, to empower educators and students across the country!"],"eb3Quv":["What can Ambassadors do?"],"/j6q09":["All ambassadors are expected to share Khan Academy and support its use within their school and online communities. Here are some ways you might do that:"],"zV70QN":["Serve as “go-to” Khan Academy leader in your school community"],"MEYox+":["Support peers with getting Khan Academy kicked off and used regularly in the classroom, sharing your tips and tricks along the way"],"IfwZNJ":["Lead trainings and PD sessions"],"x9qG9O":["Introduce Khan Academy in the ways you find most impactful, like through school or district-wide PD sessions, lunch-n-learns, or 1:1 onboarding sessions"],"tVJWgP":["Spread our mission of a free, world-class education through online channels"],"KRX8nX":["Make people aware of Khan Academy’s mission, products, and initiatives by leading chats, posting on social media, writing blog posts, and more"],"BLtdIn":["Engage with other Ambassadors within our network"],"xGXiYq":["Exchange best practices and learn from fellow leaders in the field"],"IF/W87":["Help fellow educators on online support forums"],"kyT8hB":["If you love providing specific Khan Academy guidance to educators across the world, you can work directly with our staff by answering questions in our online community forum"],"3y0I42":["Present at conferences and education events"],"eWtAdd":["Share your professional expertise and represent Khan Academy along the way"],"5HSzYq":["What are the perks of being an Ambassador?"],"tzSZps":["Make a critical impact in advancing educational equity"],"qwAYUc":["Receive resources and support to make a huge, powerful difference in the lives of educators and students"],"xqVdKd":["Build your professional network"],"4tFZi6":["Membership in a powerful, private network of expert teachers and leaders. Join and lead conversations about education topics important to you"],"gxK/Td":["Make your voice heard"],"ecoPvZ":["Direct access and ability to give feedback to Khan Academy staff in order to directly impact what we build for millions of learners and educators!"],"sZEr8n":["Receive early, priority access"],"mMO165":["First chance to test out new features and products whenever possible"],"gRzLv1":["Receive swag and special opportunities"],"nzgzX+":["Special gifts from our Khan Academy team to rep your role as an Ambassador, as well as access to Ambassador-specific opportunities throughout the year"],"o+hWS2":["Share your title and get recognized for your great work"],"4e1QoX":["An official Khan Academy Ambassador badge for your communications and listing on our website’s Ambassador directory. Shout outs in newsletters and media opportunities when available"],"GbzpXU":["All K-12 teachers, instructional coaches, or school and district administrators in the United States who currently use Khan Academy are eligible to apply. This is a volunteer opportunity. If you have any questions, please contact us at"],"CxUG/h":["ambassadors@khanacademy.org"],"FEavPY":["Note: Space is limited and, as much as we wish we had capacity to work closely with everyone, we will not be able to accept all eligible applicants into this year’s program. We will close applications after all spots are filled."]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["ur","uk","te","or","zh-hant","sk","sgn-us","rw","is","fv","en-x-rtl","az","zu","xh","th","sw","fa","ms","he","fa-af","ar","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["es","vi","sr","ro","nb","km","hi","fr","ru","pt-pt","nl","my","mn","ky","kk","it","hu","gu","cs"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
